<div>
	<div class="actions-container">
		<div class="action-card">
			<div class="action-info">
				<mat-icon color="accent">cloud_upload</mat-icon>
				<span class="action-title">Inclusão</span>
			</div>
			<div class="action-buttons">
				<button
					mat-stroked-button
					color="primary"
					class="download-button"
					(click)="onFileDownload(actionType.INCLUSION)"
					[class.download-button-loading]="
						isDownloadLoading('templateInclusion')
					"
					[disabled]="isDownloadDisabled('templateInclusion')"
				>
					<mat-spinner
						*ngIf="isDownloadLoading('templateInclusion')"
						class="download-button-icon"
						diameter="20"
					></mat-spinner>
					<mat-icon
						*ngIf="!isDownloadLoading('templateInclusion')"
						class="download-button-icon"
						svgIcon="sanus-download"
					></mat-icon>
					<span>Baixar Modelo</span>
				</button>
				<label mat-stroked-button for="inputInclusion" class="upload-button">
					<mat-icon svgIcon="sanus-upload"></mat-icon>
					<span>Importar Arquivo</span>
				</label>
				<input
					#fileInputInclusion
					id="inputInclusion"
					type="file"
					[multiple]="false"
					(change)="onFileUpload(actionType.INCLUSION, $event)"
					class="file-input"
				/>
			</div>
		</div>

		<div class="action-card">
			<div class="action-info">
				<mat-icon class="orange-icon">update</mat-icon>
				<span class="action-title">Atualização</span>
			</div>
			<div class="action-buttons">
				<button
					mat-stroked-button
					color="primary"
					class="download-button"
					(click)="onFileDownload(actionType.UPDATE)"
					[class.download-button-loading]="isDownloadLoading('templateUpdate')"
					[disabled]="isDownloadDisabled('templateUpdate')"
				>
					<mat-spinner
						*ngIf="isDownloadLoading('templateUpdate')"
						class="download-button-icon"
						diameter="20"
					></mat-spinner>
					<mat-icon
						*ngIf="!isDownloadLoading('templateUpdate')"
						class="download-button-icon"
						svgIcon="sanus-download"
					></mat-icon>
					<span>Baixar Modelo</span>
				</button>
				<label mat-stroked-button for="inputUpdate" class="upload-button">
					<mat-icon svgIcon="sanus-upload"></mat-icon>
					<span>Importar Arquivo</span>
				</label>
				<input
					#fileInputUpdate
					id="inputUpdate"
					type="file"
					[multiple]="false"
					(change)="onFileUpload(actionType.UPDATE, $event)"
					class="file-input"
				/>
			</div>
		</div>

		<div class="action-card">
			<div class="action-info">
				<mat-icon class="blue-icon">swap_horiz</mat-icon>
				<span class="action-title">Transferência Imediata</span>
			</div>
			<div class="action-buttons">
				<button
					mat-stroked-button
					color="primary"
					class="download-button"
					(click)="onFileDownload(actionType.TRANSFER)"
					[class.download-button-loading]="
						isDownloadLoading('templateTransfer')
					"
					[disabled]="isDownloadDisabled('templateTransfer')"
				>
					<mat-spinner
						*ngIf="isDownloadLoading('templateTransfer')"
						class="download-button-icon"
						diameter="20"
					></mat-spinner>
					<mat-icon
						*ngIf="!isDownloadLoading('templateTransfer')"
						class="download-button-icon"
						svgIcon="sanus-download"
					></mat-icon>
					<span>Baixar Modelo</span>
				</button>
				<label mat-stroked-button for="inputTransfer" class="upload-button">
					<mat-icon svgIcon="sanus-upload"></mat-icon>
					<span>Importar Arquivo</span>
				</label>
				<input
					#fileInputTransfer
					id="inputTransfer"
					type="file"
					[multiple]="false"
					(change)="onFileUpload(actionType.TRANSFER, $event)"
					class="file-input"
				/>
			</div>
		</div>

		<div class="action-card">
			<div class="action-info">
				<mat-icon class="blue-icon">alarm</mat-icon>
				<span class="action-title">Transferência (com agendamento)</span>
			</div>
			<div class="action-buttons">
				<button
					mat-stroked-button
					color="primary"
					class="download-button"
					(click)="onFileDownload(actionType.SCHEDULED_TRANSFER)"
					[class.download-button-loading]="
						isDownloadLoading('templateScheduledTransfer')
					"
					[disabled]="isDownloadDisabled('templateScheduledTransfer')"
				>
					<mat-spinner
						*ngIf="isDownloadLoading('templateScheduledTransfer')"
						class="download-button-icon"
						diameter="20"
					></mat-spinner>
					<mat-icon
						*ngIf="!isDownloadLoading('templateScheduledTransfer')"
						class="download-button-icon"
						svgIcon="sanus-download"
					></mat-icon>
					<span>Baixar Modelo</span>
				</button>
				<label mat-stroked-button for="inputTransfer" class="upload-button">
					<mat-icon svgIcon="sanus-upload"></mat-icon>
					<span>Importar Arquivo</span>
				</label>
				<input
					#fileInputTransfer
					id="inputTransfer"
					type="file"
					[multiple]="false"
					(change)="onFileUpload(actionType.SCHEDULED_TRANSFER, $event)"
					class="file-input"
				/>
			</div>
		</div>

		<div class="action-card">
			<div class="action-info">
				<mat-icon color="warn">delete_forever</mat-icon>
				<span class="action-title">Exclusão</span>
			</div>
			<div class="action-buttons">
				<button
					mat-stroked-button
					color="primary"
					class="download-button"
					(click)="onFileDownload(actionType.EXCLUSION)"
					[class.download-button-loading]="
						isDownloadLoading('templateExclusion')
					"
					[disabled]="isDownloadDisabled('templateExclusion')"
				>
					<mat-spinner
						*ngIf="isDownloadLoading('templateExclusion')"
						class="download-button-icon"
						diameter="20"
					></mat-spinner>
					<mat-icon
						*ngIf="!isDownloadLoading('templateExclusion')"
						class="download-button-icon"
						svgIcon="sanus-download"
					></mat-icon>
					<span>Baixar Modelo</span>
				</button>
				<label mat-stroked-button for="inputExclusion" class="upload-button">
					<mat-icon svgIcon="sanus-upload"></mat-icon>
					<span>Importar Arquivo</span>
				</label>
				<input
					#fileInputExclusion
					id="inputExclusion"
					type="file"
					[multiple]="false"
					(change)="onFileUpload(actionType.EXCLUSION, $event)"
					class="file-input"
				/>
			</div>
		</div>

		<div class="action-card">
			<div class="action-info">
				<mat-icon>list_alt</mat-icon>
				<span class="action-title">Beneficiários ativos</span>
			</div>
			<div class="action-buttons">
				<button
					mat-stroked-button
					color="primary"
					class="download-button"
					(click)="onActiveDataDownload()"
					[class.download-button-loading]="
						isDownloadLoading('activeBeneficiaries')
					"
					[disabled]="isDownloadDisabled('activeBeneficiaries')"
				>
					<mat-spinner
						*ngIf="isDownloadLoading('activeBeneficiaries')"
						class="download-button-icon"
						diameter="20"
					></mat-spinner>
					<mat-icon
						*ngIf="!isDownloadLoading('activeBeneficiaries')"
						class="download-button-icon"
						svgIcon="sanus-download"
					></mat-icon>
					<span>Baixar Relatório</span>
				</button>
			</div>
		</div>

		<div class="action-card">
			<div class="action-info">
				<mat-icon class="grey-icon">list_alt</mat-icon>
				<span class="action-title">Beneficiários inativos</span>
			</div>
			<div class="action-buttons">
				<button
					mat-stroked-button
					color="primary"
					class="download-button"
					(click)="onInactiveDataDownload()"
					[class.download-button-loading]="
						isDownloadLoading('inactiveBeneficiaries')
					"
					[disabled]="isDownloadDisabled('inactiveBeneficiaries')"
				>
					<mat-spinner
						*ngIf="isDownloadLoading('inactiveBeneficiaries')"
						class="download-button-icon"
						diameter="20"
					></mat-spinner>
					<mat-icon
						*ngIf="!isDownloadLoading('inactiveBeneficiaries')"
						class="download-button-icon"
						svgIcon="sanus-download"
					></mat-icon>
					<span>Baixar Relatório</span>
				</button>
			</div>
		</div>

		<ng-container *ngIf="isMatriz">
			<div class="action-card">
				<div class="action-info">
					<mat-icon>library_books</mat-icon>
					<span class="action-title">Relatório de ativos do grupo</span>
				</div>
				<div class="action-buttons">
					<button
						mat-stroked-button
						color="primary"
						class="download-button"
						(click)="onActiveDataDownload(true)"
						[class.download-button-loading]="
							isDownloadLoading('groupActiveBeneficiaries')
						"
						[disabled]="isDownloadDisabled('groupActiveBeneficiaries')"
					>
						<mat-spinner
							*ngIf="isDownloadLoading('groupActiveBeneficiaries')"
							class="download-button-icon"
							diameter="20"
						></mat-spinner>
						<mat-icon
							*ngIf="!isDownloadLoading('groupActiveBeneficiaries')"
							class="download-button-icon"
							svgIcon="sanus-download"
						></mat-icon>
						<span>Baixar Relatório</span>
					</button>
				</div>
			</div>

			<div class="action-card">
				<div class="action-info">
					<mat-icon class="grey-icon">library_books</mat-icon>
					<span class="action-title">Relatório de inativos do grupo</span>
				</div>
				<div class="action-buttons">
					<button
						mat-stroked-button
						color="primary"
						class="download-button"
						(click)="onInactiveDataDownload(true)"
						[class.download-button-loading]="
							isDownloadLoading('groupInactiveBeneficiaries')
						"
						[disabled]="isDownloadDisabled('groupInactiveBeneficiaries')"
					>
						<mat-spinner
							*ngIf="isDownloadLoading('groupInactiveBeneficiaries')"
							class="download-button-icon"
							diameter="20"
						></mat-spinner>
						<mat-icon
							*ngIf="!isDownloadLoading('groupInactiveBeneficiaries')"
							class="download-button-icon"
							svgIcon="sanus-download"
						></mat-icon>
						<span>Baixar Relatório</span>
					</button>
				</div>
			</div>
		</ng-container>
	</div>
</div>
